import { render, staticRenderFns } from "./BonusListFilter.vue?vue&type=template&id=2c8619c7&"
import script from "./BonusListFilter.vue?vue&type=script&lang=js&"
export * from "./BonusListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports